import React from 'react';
import TOLogo from '../../../../static/images/TO/toyota-logo.svg'
import Row from 'react-bootstrap/Row'
import Image from 'react-bootstrap/Image'
import Button from 'react-bootstrap/Button'
import AppVars from '../../../../AppVars';
import Logger from '../../../../Logger';

let appVars = AppVars.getInstance()
let logger = Logger.getInstance()

class UserExistsView extends React.Component{
    constructor(props){
        super(props);
        this.state ={

        }
    }

    componentDidMount(){
        logger.log('stage', this.props.style)
        logger.log('stage', appVars.getRegisterURL(this.props.style))
    }

    render(){
        return (
            <div>
            <div className = "justify-content-center line-box">
                <div role = "banner">
                    <Row className = "">
                    <a href = {appVars.getAppHomeURL(this.props.style)}><Image className = "corner-logo absolute" alt = "Toyota" src={require('../../../../static/images/Toyota-Logo.svg').default} /></a>
                    </Row>
                </div>
                <div role = "main">
                    <Row className = "justify-content-center location">
                        <div>Registration</div>
                    </Row>
                    <Row className = "title__TO left">Sign In</Row>
                    <Row className = "justify-content-center text__TO">
                        <b>{this.props.email}</b> is already registered for Toyota Owners, My Lexus or Toyota App. Use the same credentials to sign in to Toyota.
                    </Row>
                    <Row className = "justify-content-center text__TO">
                        Do you need help with your account? <br className = "mobile-br"/> <a style = {{"marginTop" : "0px"}} className = "create-account" href = {appVars.getSupportURL(this.props.style)}>Contact Us</a>
                    </Row>
                    <div style = {{'height' : '39px'}}>
                    </div>
                    <div style = {{'display' : 'grid', 'grid-template-rows' : '58px', 'grid-template-columns' : '90px auto', 'margin' : 'auto'}}>
                    <a href= "/"><Button style = {{'margin' : 'auto'}}data-testid = "SignInButton" bsPrefix = "button__TO" type = "button" >Sign In</Button></a>
                    <a className = "button-left create-account" href= {appVars.getResendActivationEmailURL(this.props.style)}>Resend Activation Link</a>
                    </div>
                    <div>
                    <div style = {{'height' : '5px'}}>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        )
  }
}

export default UserExistsView;